export enum couponCodeTypes {
  NO_CODE = "noCode",
  CORPORATE_CODE = "corporateCode",
  SPECIAL_CODE = "specialCode",
}
